import React from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

// Date 
import format from 'date-fns/format'
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import { de } from 'date-fns/locale/de';

// Semantic UI
import { Button, Label, Segment, Table } from "semantic-ui-react";

// Components
import { unstickSection } from "./contractSlice";

// Styles
import './contract.css';

//
registerLocale('de', de);
setDefaultLocale('de');



/**
 * 
 * @returns 
 */
const Max2ContractSeasonRoomsSticky = () => {
  // global State
  const dispatch = useDispatch();
  const Contract = useSelector((state) => state.contract.data.Contract);
  
  // i18n
  const { t } = useTranslation(); 

  // build room lables
  const rooms = Contract.Rooms.map((room) => {
    return <Label key={room.RoomCode} color="blue">{room.RoomCode}</Label>
  })

  // determine max season rows
  let maxSeasonRows = 0;
  let seasonsToDisplay = [];
  for (const seasonKey in Contract.Seasons) {
    if (Object.prototype.hasOwnProperty.call(Contract.Seasons, seasonKey)) {
      seasonsToDisplay.push(seasonKey);
      if (Contract.Seasons[seasonKey].length > maxSeasonRows) {
        maxSeasonRows = Contract.Seasons[seasonKey].length;
      }
    }
  }

  // build table header cells
  const headerSeasons = seasonsToDisplay.map((seasonKey, seasonIndex) => {
    const headerSeasonsPeriods = Contract.Seasons[seasonKey].map((period, index) => {
      if (!period.Start || !period.End) {
        return <></>
      }
      const fdateStart = format(new Date(period.Start), 'dd.MM.')
      const fdateEnd = format(new Date(period.Start), 'dd.MM.')
      return (
        <span key={index}>{fdateStart} - {fdateEnd}<br /></span>
      )
    });
    return (
      <Table.HeaderCell key={seasonKey} className={seasonIndex % 2 ? 'season even' : 'season odd'} textAlign="center">
        {headerSeasonsPeriods}
      </Table.HeaderCell>
    )
  });
  /**/

  return (
    <>
      <Segment style={{backgroundColor: '#eee'}}>
        <div style={{float:'left', marginRight:'20px', textAlign:'left'}}>
          {t('contract.seasonRooms.sticky.hotelNameLabel')}: {Contract.HotelName} <br />
          {t('contract.seasonRooms.sticky.roomsLabel')}: {rooms}
        </div>
        <div style={{display: 'inline-block'}}>
          <Table celled structured singleLine basic='very'>
            <Table.Body style={{borderTop: '0px'}}>
              <Table.Row>
                {seasonsToDisplay.map((seasonKey, seasonIndex) => (
                  <Table.HeaderCell key={seasonKey} className={seasonIndex % 2 ? 'season even' : 'season odd'} textAlign="center">{seasonKey}</Table.HeaderCell>
                ))}
              </Table.Row>
            </Table.Body>
            <Table.Body>
              <Table.Row>
                {headerSeasons}
              </Table.Row>
            </Table.Body>
          </Table>
        </div>
        <div style={{position: 'absolute', right: '10px', top: '10px'}}>
          <Button basic circular icon='times' floated="right" onClick={()=>dispatch(unstickSection('SeasonRooms'))} />
        </div>
      </Segment>
      
    </>
  );
}

export default Max2ContractSeasonRoomsSticky;